import React from 'react';
import { Heart, Star, Coins, Trophy } from 'lucide-react';

const UserStats = ({ stats }) => {
    const { level, xp, maxXp, health, maxHealth, coins } = stats;

    const xpPercentage = Math.min((xp / maxXp) * 100, 100);
    const healthPercentage = Math.min((health / maxHealth) * 100, 100);

    return (
        <div className="glass-card p-4 mb-6 rounded-xl border border-white/10">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">

                {/* Level & Avatar */}
                <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center text-dark-bg font-bold text-xl shadow-lg border-2 border-white/20">
                        {level}
                    </div>
                    <div>
                        <h3 className="text-white font-semibold text-lg flex items-center gap-2">
                            <Trophy size={16} className="text-yellow-400" />
                            Level {level}
                        </h3>
                        <div className="flex items-center gap-2 text-white/60 text-sm">
                            <Coins size={14} className="text-yellow-300" />
                            <span>{coins} Coins</span>
                        </div>
                    </div>
                </div>

                {/* Stats Bars */}
                <div className="flex-1 w-full grid grid-cols-1 md:grid-cols-2 gap-4">

                    {/* Health Bar */}
                    <div className="flex flex-col gap-1">
                        <div className="flex justify-between text-xs font-medium">
                            <span className="text-red-400 flex items-center gap-1">
                                <Heart size={12} fill="currentColor" /> Health
                            </span>
                            <span className="text-white/60">{Math.ceil(health)} / {maxHealth}</span>
                        </div>
                        <div className="h-3 bg-dark-bg/50 rounded-full overflow-hidden border border-white/5">
                            <div
                                className="h-full bg-gradient-to-r from-red-500 to-pink-500 transition-all duration-500 ease-out"
                                style={{ width: `${healthPercentage}%` }}
                            />
                        </div>
                    </div>

                    {/* XP Bar */}
                    <div className="flex flex-col gap-1">
                        <div className="flex justify-between text-xs font-medium">
                            <span className="text-yellow-400 flex items-center gap-1">
                                <Star size={12} fill="currentColor" /> Experience
                            </span>
                            <span className="text-white/60">{Math.floor(xp)} / {maxXp}</span>
                        </div>
                        <div className="h-3 bg-dark-bg/50 rounded-full overflow-hidden border border-white/5">
                            <div
                                className="h-full bg-gradient-to-r from-yellow-400 to-orange-500 transition-all duration-500 ease-out"
                                style={{ width: `${xpPercentage}%` }}
                            />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default UserStats;
